export default __webpack_public_path__ + "static/media/gardening.4cafb1d7.png";